import { Home, Search, Link2, Phone } from "lucide-react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { CONTACT } from "@/data/content";

const item = "flex flex-1 flex-col items-center justify-center gap-1 py-2.5 text-[11px] font-medium transition-colors";

export function MobileBottomNav() {
  const loc = useLocation();
  const [params] = useSearchParams();
  const onSofi = loc.pathname === "/sofi";
  const mode = params.get("mode");
  const active = (k) => {
    if (k === "home") return loc.pathname === "/";
    if (k === "find") return onSofi && mode !== "url";
    if (k === "url") return onSofi && mode === "url";
    return false;
  };
  const cls = (k) => `${item} ${active(k) ? "text-[#C73D3A]" : "text-white/55 hover:text-white"}`;

  return (
    <nav data-testid="mobile-bottom-nav"
      className="fixed bottom-0 left-0 z-50 flex w-full border-t border-white/10 bg-[#0d0d0d]/95 backdrop-blur-xl lg:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      <Link to="/" data-testid="botnav-home" className={cls("home")}>
        <Home className="h-5 w-5" /> Домів
      </Link>
      <Link to="/sofi?mode=find" data-testid="botnav-find" className={cls("find")}>
        <Search className="h-5 w-5" /> Найти авто
      </Link>
      <Link to="/sofi?mode=url" data-testid="botnav-url" className={cls("url")}>
        <Link2 className="h-5 w-5" /> Посилання
      </Link>
      <a href={`tel:${CONTACT.phoneRaw}`} data-testid="botnav-contact" className={cls("contact")}>
        <Phone className="h-5 w-5" /> Контакт
      </a>
    </nav>
  );
}
